import { useMemo } from 'react';
import { PRIVACY_POLICY_URL } from '../../../constants';
import { TextColor } from '../../../types';
import { Accordion, Dialog, SubmitFile, Typography, TypographyType } from '../../shared';
import SubmitLink from './SubmitLink';

const UPLOAD_MODAL_WIDTH = 760;

enum UploadItemType {
  FILE = 'FILE',
  LINK = 'LINK',
}

interface UploadModalProps {
  onClose: () => void;
}

const UploadModal = ({ onClose }: UploadModalProps) => {
  const items = useMemo(
    () => [
      {
        id: UploadItemType.FILE,
        title: 'Submit a file',
        content: (
          <SubmitFile
            successToastData={{
              title: 'Processing',
              message:
                'Enhancing your simulations now! We’ll email you when this is complete, usually within a few hours.',
            }}
          />
        ),
      },
      {
        id: UploadItemType.LINK,
        title: 'Submit a link',
        content: <SubmitLink />,
      },
    ],
    []
  );

  return (
    <Dialog
      isOpen
      onClose={onClose}
      title="Improve your organization’s simulations"
      size={UPLOAD_MODAL_WIDTH}
      description={
        <Typography type={TypographyType.BASE} color={TextColor.SECONDARY}>
          Make your simulations more realistic by sharing material on your ICP, training material, past calls, or
          industry specific knowledge.
        </Typography>
      }
    >
      <div className="flex flex-col gap-4">
        <Accordion items={items.map((item) => ({ ...item, content: <div className="w-[90%]">{item.content}</div> }))} />
        <Typography type={TypographyType.X_SMALL} color={TextColor.SECONDARY}>
          What you upload and share is private to your workspace. It is used to create realistic simulations, we do not
          train AI models using this information.&nbsp;
          <span className="cursor-pointer underline" onClick={() => window.open(PRIVACY_POLICY_URL, '_blank')}>
            Privacy policy
          </span>
        </Typography>
      </div>
    </Dialog>
  );
};

export default UploadModal;
